import React, { useEffect, useState } from "react";
import Login from "./app/screens/authScreens/Login";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "./components/Navbar";
import "./App.css";
import Header from "./components/Header";
import { Profile } from "./app/screens/mainScreens/Profile";
import Department from "./app/screens/mainScreens/department";
import ModalManager from "./components/modalManager";
import SubDepartment from "./app/screens/mainScreens/subDepartment";
import RoleManagement from "./app/screens/mainScreens/role";
import OpenPositionManagement from "./app/screens/mainScreens/openPosition";
import RoundManagement from "./app/screens/mainScreens/roundOpening";
import InterviewList from "./app/screens/mainScreens/interviewList";
import JobOpeningDetails from "./app/screens/mainScreens/openPosition/details/index";
import Organization from "./app/screens/mainScreens/organization";
import Loader from "./components/Loader";
import CandidateDetailsTable from "./app/screens/mainScreens/openPosition/details/components/CandidateDetails";
import { Toaster } from "react-hot-toast";
import ApplicantDataTable from "./components/ApplicantDataTable";
import CandidateDataTable from "./components/AddApplicantTable/CandidateDataTable";
import CandidateJobOpenings from "./app/screens/mainScreens/openPosition/details/components/CandidateJobOpenings";
import CandidateInterviewDetails from "./app/screens/mainScreens/openPosition/details/components/CandidateInterviewDetails";
import QuestionList from "./components/QuestionList";
import ReportCard from "./app/screens/mainScreens/ReportCard";
import ReactLiveCodeEditor from "./app/screens/mainScreens/CodePreview/ReactLiveCodeEditor";
import ReportCardCandidate from "./app/screens/mainScreens/ReportCard/ReportCardCandidate";

const Main = () => {
  const [token, setToken] = useState(() => localStorage.getItem("accessToken"));
  const tokenfunc = useSelector((state) => state.user.tokenfunc);
  const navbar = useSelector((state) => state.user.navbar);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [authChecking, setAuthChecking] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if token exists in localStorage
    const checkAuth = async () => {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        setToken(accessToken);
      }
      setAuthChecking(false);
    };

    checkAuth();
  }, []);

  useEffect(() => {
    const savedPath = localStorage.getItem("lastVisitedPath");
    if ((tokenfunc || token) && location.pathname === "/" && !authChecking) {
      navigate(savedPath || location.pathname, { replace: true });
    }
  }, [token, tokenfunc, authChecking]);

  useEffect(() => {
    if ((tokenfunc || token) && location.pathname !== "/") {
      localStorage.setItem("lastVisitedPath", location.pathname);
    }
  }, [location.pathname, token, tokenfunc]);

  if (authChecking) {
    return <Loader />; // Show loader while checking authentication
  }
  const isReportCard =
    window.location.pathname?.includes("/report-card") ||
    window.location.pathname?.includes("/candidate-report-card") ||
    window.location.pathname?.includes("/code-preview");
  return (
    <>
      <Toaster />
      {tokenfunc || token ? (
        <div>
          {isLoading && !isReportCard && <Loader />}
          {!isReportCard && (
            <>
              <Header />
              <Navbar />
            </>
          )}

          <div

            className={`main ${navbar && !isReportCard ? "open" : "closed"}`}

          >
            <Routes>
              <Route path="/" element={<Department />} />
              <Route path="/sub-department" element={<SubDepartment />} />
              <Route path="/role" element={<RoleManagement />} />
              <Route path="/organization" element={<Organization />} />
              <Route
                path="/open-position"
                element={<OpenPositionManagement />}
              />
              <Route
                path="/job-opening-details/:id?"
                element={<JobOpeningDetails />}
              />
              <Route
                path="/round-management/:id?"
                element={<RoundManagement />}
              />
              <Route
                path="/candidate-details"
                element={<CandidateDetailsTable />}
              />
              <Route path="/interview-list" element={<InterviewList />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/applicant-list" element={<ApplicantDataTable />} />
              <Route path="/candidate-list" element={<CandidateDataTable />} />
              <Route
                path="/candidate-job-openings"
                element={<CandidateJobOpenings />}
              />
              <Route
                path="/candidate-interviews"
                element={<CandidateInterviewDetails />}
              />
              <Route path="/question-list" element={<QuestionList />} />
              <Route path="/report-card/:id?" element={<ReportCard />} />
              <Route
                path="/candidate-report-card/:id?"
                element={<ReportCardCandidate />}
              />
              <Route

              path="/code-preview/:id?"
              element={<ReactLiveCodeEditor />}
            />

         
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </div>
      ) : (
        <>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/report-card/:id?" element={<ReportCard />} />
            <Route
              path="/candidate-report-card/:id?"
              element={<ReportCardCandidate />}
            />

            <Route
              path="/code-preview/:id?"
              element={<ReactLiveCodeEditor />}
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </>
      )}
    </>
  );
};

export default Main;
